import { useParams, useSearchParams } from 'react-router-dom';

export const useSlackCallbackParams = () => {
  const { status = 'failure' } = useParams<{ status: 'success' | 'failure' }>();

  const [searchParams] = useSearchParams();
  const appId = searchParams.get('appId');
  const teamId = searchParams.get('teamId');
  // Slack sends `access_denied` when the user cancels on its consent screen;
  // the API passes it through to the failure redirect.
  const isCancelled = searchParams.get('error') === 'access_denied';

  return { status, appId, teamId, isCancelled };
};
